module.exports = __webpack_public_path__ + "static/media/failure.d0ea455b.svg";